export default {
      id: "common__tractor-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__tractor",
      toString: function () {
        return this.url;
      }
    }